/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { AnyNonRedactedAutoTestStepAsJSON } from './AnyNonRedactedAutoTestStepAsJSON';
import { JunitTestExtra } from './JunitTestExtra';
const JunitTestAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(JunitTestExtra, AnyNonRedactedAutoTestStepAsJSON);
export class JunitTestAsJSON extends AnyNonRedactedAutoTestStepAsJSON {
    static decode(input) {
        return JunitTestAsJSONParser.decode(input).map(res => new JunitTestAsJSON(res));
    }
    static unsafeDecode(input) {
        return JunitTestAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JunitTestAsJSONParser.encode(data);
    }
    static schema() {
        return JunitTestAsJSONParser.schema();
    }
}
